import { useId } from 'react';

import type { FieldIds } from './field.types';

export const useFieldIds = (idProp?: string): FieldIds => {
  const generated = useId();
  const id = idProp ?? `field${generated}`;
  return { id, labelId: `${id}-label`, helperId: `${id}-helper` };
};
